import { apiGet, apiPost, apiPut, apiDelete, apiPatch } from '@/services/api/apiClient';
import {
  CreateBusinessRequest,
  UpdateBusinessRequest,
  BusinessListParams,
  BusinessResponse,
  BusinessListResponse,
} from '@/constants/types';

export const businessService = {
  // User APIs - Create, Read, Update, Delete own business
  async getMyBusinesses(params?: BusinessListParams): Promise<BusinessListResponse> {
    const searchParams = new URLSearchParams();

    if (params?.page) searchParams.append('page', params.page.toString());
    if (params?.limit) searchParams.append('limit', params.limit.toString());

    return await apiGet<BusinessListResponse>(`/business/my-businesses?${searchParams.toString()}`);
  },

  async getAllBusinesses(params?: BusinessListParams): Promise<BusinessListResponse> {
    const searchParams = new URLSearchParams();

    if (params?.search) searchParams.append('search', params.search);
    if (params?.businessCategory) searchParams.append('businessCategory', params.businessCategory);
    if (params?.city) searchParams.append('city', params.city);
    if (params?.state) searchParams.append('state', params.state);
    if (params?.isVerified !== undefined) searchParams.append('isVerified', params.isVerified.toString());
    if (params?.page) searchParams.append('page', params.page.toString());
    if (params?.limit) searchParams.append('limit', params.limit.toString());
    if (params?.sort) searchParams.append('sort', params.sort);

    return await apiGet<BusinessListResponse>(`/business?${searchParams.toString()}`);
  },

  async getBusiness(id: string): Promise<BusinessResponse> {
    return await apiGet<BusinessResponse>(`/business/${id}`);
  },

  async createBusiness(data: CreateBusinessRequest): Promise<BusinessResponse> {
    return await apiPost<BusinessResponse>('/business', data);
  },

  async updateBusiness(id: string, data: UpdateBusinessRequest): Promise<BusinessResponse> {
    return await apiPut<BusinessResponse>(`/business/${id}`, data);
  },

  async deleteBusiness(id: string): Promise<{ success: boolean; message: string }> {
    return await apiDelete<{ success: boolean; message: string }>(`/business/${id}`);
  },

  // Super Admin APIs
  async approveBusiness(id: string): Promise<BusinessResponse> {
    return await apiPatch<BusinessResponse>(`/business/${id}/approve`);
  },

  async rejectBusiness(id: string, reason: string): Promise<BusinessResponse> {
    return await apiPatch<BusinessResponse>(`/business/${id}/reject`, { reason });
  },

  async setInReview(id: string): Promise<BusinessResponse> {
    return await apiPatch<BusinessResponse>(`/business/${id}/in-review`);
  },

  async requestClarification(id: string, note: string): Promise<BusinessResponse> {
    return await apiPatch<BusinessResponse>(`/business/${id}/clarification`, { note });
  },

  async suspendBusiness(id: string): Promise<BusinessResponse> {
    return await apiPatch<BusinessResponse>(`/business/${id}/suspend`);
  },

  async activateBusiness(id: string): Promise<BusinessResponse> {
    return await apiPatch<BusinessResponse>(`/business/${id}/activate`);
  },

  async blockBusiness(id: string): Promise<BusinessResponse> {
    return await apiPatch<BusinessResponse>(`/business/${id}/block`);
  },

  async unblockBusiness(id: string): Promise<BusinessResponse> {
    return await apiPatch<BusinessResponse>(`/business/${id}/unblock`);
  },
};
